import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Samma Firebase-projekt som Qid använder (qvenari-prod) — det är vad som
// gör att ett konto skapat här (t.ex. via Google) är samma identitet som
// gäller på övriga Q-appar (Qvenari m.fl.), utan att det märks för
// användaren att en delad identitetstjänst ligger bakom. Konfigurationen
// är inte hemlig (motsvarar ett publikt klient-ID) — riktig autentisering
// sker hos Google/Firebase och verifieras sedan server-side i Qvestiums
// eget API (routes/auth.ts POST /auth/firebase-login), som i sin tur
// verifierar mot Qid.
//
// OBS: denna fil importerar medvetet INTE @qos/qid-client/browser (som
// har identisk kod) — det paketet är länkat via pnpm:s link:-protokoll
// och får därför sin EGEN separata kopia av `firebase`-paketet i sitt eget
// node_modules, skild från appens egen. Att blanda en Auth/Provider-
// instans från den ena kopian med signInWithPopup från den andra (som
// api.ts importerar direkt) ger `auth/argument-error` — Firebase SDK:et
// kräver att alla instanser kommer från samma modul-kopia. Upptäckt
// 2026-09-29 när Google-inloggningen slutade fungera i produktion.
const firebaseConfig = {
  apiKey: 'AIzaSyBF3kXT7_LEPgBpP8fiapn7RoNT7Dc5jkQ',
  authDomain: 'qvenari-prod.firebaseapp.com',
  projectId: 'qvenari-prod',
  storageBucket: 'qvenari-prod.firebasestorage.app',
  messagingSenderId: '570330887175',
  appId: '1:570330887175:web:fac2fa342640227d94e6a2',
};

export const firebaseApp = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
// Utan detta väljer Google automatiskt senast använda konto istället för att
// visa kontoväljaren — t.ex. om man vill logga in med ett annat Google-konto.
googleProvider.setCustomParameters({ prompt: 'select_account' });
